// extracted by mini-css-extract-plugin
module.exports = {"login":"login--1QN-d","form":"form--3LBnZ","verifyCode":"verifyCode--3Is_1","button":"button--2PKe1"};